<template>
    <div class="water">
        <h1>采暖统计</h1>
        <div class="line"></div>
        <div class="content">
            <div class="item title">
                <p>空调用户</p>
            </div>
            <div class="item">
                <p>采暖用户</p>
            </div>
            <div class="item">
                <p>#1分水器温度</p>
                <p>{{items.find(item => item.name === "en_25.PV")?.val}}℃</p>
            </div>
            <div class="item">
                <p>#1集水器温度</p>
                <p>{{items.find(item => item.name === "en_26.PV")?.val}}℃</p>
            </div>
            <div class="item">
                <p>#2分水器温度</p>
                <p>{{items.find(item => item.name === "en_27.PV")?.val}}℃</p>
            </div>
            <div class="item">
                <p>#2集水器温度</p>
                <p>{{items.find(item => item.name === "en_28.PV")?.val}}℃</p>
            </div>
            <div class="item">
                <p>#1分水器压力</p>
                <p>{{items.find(item => item.name === "en_53.PV")?.val}}MPa</p>
            </div>
            <div class="item">
                <p>#1集水器压力</p>
                <p>{{items.find(item => item.name === "en_54.PV")?.val}}MPa</p>
            </div>
            <div class="item">
                <p>#2分水器压力</p>
                <p>{{items.find(item => item.name === "en_55.PV")?.val}}MPa</p>
            </div>
            <div class="item">
                <p>#2集水器压力</p>
                <p>{{items.find(item => item.name === "en_56.PV")?.val}}MPa</p>
            </div>
        </div>
    </div>
</template>
<script>
import { getRequest, postRequest } from "@/common/config/realTimeRequest.js";
export default {
    props: {
    },
    data() {
        return {
            items: [],
        }
    },
    mounted() {
        this.handleGetData()
        setInterval(() => {
            this.handleGetData()
        }, 1000 * 60*5)
    },
    methods: {
        // 获取数据
        handleGetData() {
            getRequest("/api/realdata", {
                names: "en_25.PV,en_26.PV,en_27.PV,en_28.PV,en_53.PV,en_54.PV,en_55.PV,en_56.PV",
                token: sessionStorage.getItem("realTimeToken"),
                decimal: 2,
            }).then((res) => {
                if (res.code == 0) {
                    this.items = res.items
                }
            })
        },
    }
}
</script>
<style lang="less" scoped>
/*引入字体*/
@font-face {
    /*自定义文字名称*/
    font-family: "yj";
    /*字体文件的路径*/
    src: url("./1.TTF");
}

.water::v-deep {
    height: 300px;

    h1 {
        margin: 15px 18px 0px;
        height: 25px;
        font-size: 18px;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 25px;
        text-shadow: 0px 0px 8px #005EC9;
    }

    .line {
        height: 13px;
        background-image: url(@/assets/images/cockpit/title2.png);
        background-size: contain;
        background-repeat: no-repeat;
    }

    .content {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-evenly;

        .item {
            width: 50%;
            text-align: center;
            font-size: 18px;
            font-weight: 600;
            display: flex;
            align-items: center;

            p {
                margin: 8px 0;

                &:nth-child(2n) {
                    color: #e3ca46;
                }

                &:nth-child(2n-1) {
                    margin-right: 10px;
                    color: #02bbef;
                }
            }


            .red {
                color: #b7332e !important;
            }
        }

        .title {
            font-weight: 800;
            padding: 10px 0;
        }
    }
}
</style>